export interface PierFormProfile {
  id?: string
  name: string
}

export const defaultValues: PierFormProfile = {
  name: '',
}
